import { useLiveQuery } from 'dexie-react-hooks'
import { listerImpayes, type Impaye } from '../lib/impayes'
import { getBase } from '../outbox/base'
import { lister } from '../outbox/depot'
import { useFranchiseTva } from './franchise'

/** Impayés à jour (se recalcule avec les données locales) ; `undefined` tant que la base n'est pas lue. */
export function useImpayes(): Impaye[] | undefined {
  const base = getBase()
  const franchise = useFranchiseTva()
  return useLiveQuery(async () => {
    const [devis, situations, clients] = await Promise.all([lister(base, 'devis'), base.situations.filter((s) => !s._deleted).toArray(), lister(base, 'clients')])
    return listerImpayes(devis, situations, clients, franchise, new Date().toISOString().slice(0, 10))
  }, [franchise])
}
